"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationControllerApi = exports.NotificationControllerApiFactory = exports.NotificationControllerApiFp = exports.NotificationControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * NotificationControllerApi - axios parameter creator
 * @export
 */
const NotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {PostNotification} postNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPost: (postNotification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'postNotification' is not null or undefined
            (0, common_1.assertParamExists)('apiNotificationsPost', 'postNotification', postNotification);
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postNotification, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NotificationControllerApiAxiosParamCreator = NotificationControllerApiAxiosParamCreator;
/**
 * NotificationControllerApi - functional programming interface
 * @export
 */
const NotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.NotificationControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {PostNotification} postNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPost(postNotification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiNotificationsPost(postNotification, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NotificationControllerApiFp = NotificationControllerApiFp;
/**
 * NotificationControllerApi - factory interface
 * @export
 */
const NotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.NotificationControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {PostNotification} postNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPost(postNotification, options) {
            return localVarFp.apiNotificationsPost(postNotification, options).then((request) => request(axios, basePath));
        },
    };
};
exports.NotificationControllerApiFactory = NotificationControllerApiFactory;
/**
 * NotificationControllerApi - object-oriented interface
 * @export
 * @class NotificationControllerApi
 * @extends {BaseAPI}
 */
class NotificationControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {PostNotification} postNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationControllerApi
     */
    apiNotificationsPost(postNotification, options) {
        return (0, exports.NotificationControllerApiFp)(this.configuration).apiNotificationsPost(postNotification, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NotificationControllerApi = NotificationControllerApi;
